<template>
	<div class="flex space-x-3 items-center" @mouseleave="clearVoters" v-click-outside="closeVoters">
		<a href="#" @click.prevent="vote($event, -1)"
		   v-if="canVote"
		   class="bg-transparent border-0 flex items-center justify-center cursor-pointer transition-all duration-100 p-1 rounded-full w-6 h-6 hover:bg-red-100 dark:hover:bg-red-800">

			<svg-icon
				set="local"
				icon="chevron-down"
				:class="{'text-red-500': userRate < 0, 'text-gray-400': userRate >= 0}"
				class="w-4 h-4 shrink-0"
			></svg-icon>
		</a>

		<VMenu
			ref="rateContainer"
			class="font-medium min-w-5"
			:triggers="['hover', 'click']"
			placement="bottom-end"
			:arrow-padding="8"
		>
			<div
				@mouseenter="loadVoters"
				@click="loadVoters"
				:class="{'text-green-500': rating > 0, 'text-red-500' : rating < 0}"
				class="text-center cursor-pointer">
				{{ rating }}
			</div>

			<template #popper>
				<div
					class="card card-white p-2 shadow max-h-60 w-60 overflow-y-scroll no-scroll transform translate-z-0">
					<div v-if="votersLoading" class="text-center text-sm text-gray-500 p-2">
						Ждите ответа лифтера
					</div>
					<div v-else-if="!canVote" class="text-center text-sm text-gray-500 p-2">
						Подглядывать могут только авторизованные гонкогчане
					</div>
					<div v-else>
						<div v-if="voters && voters.length" class="flex flex-col">
							<a v-for="voter in voters" :href="voter.user.url"
							   class="p-2 flex space-x-2 items-center whitespace-nowrap w-full font-normal">
								<avatar :ava="voter.user.ava" :online="voter.user.is_online" class="w-5 h-5"></avatar>
								<div class="whitespace-nowrap truncate"
									 :class="{'text-green-500': voter.rate > 0, 'text-red-500' : voter.rate < 0}">
									{{ voter.user.name }}
								</div>
							</a>
						</div>
						<div v-else class="text-center text-sm text-gray-500 p-2">
							Еще никто не оценил
						</div>
					</div>
				</div>
			</template>
		</VMenu>

		<a href="#"
		   v-if="canVote"
		   @click.prevent="vote($event, 1)"
		   class="bg-transparent border-0 flex items-center justify-center cursor-pointer w-6 h-6 rounded-full hover:bg-green-100 dark:hover:bg-green-800 duration-100 transition-all">

			<svg-icon
				set="local"
				icon="chevron-up"
				:class="{'text-green-500  stroke-green-500': userRate > 0, 'text-gray-400': userRate <= 0}"
				class="w-4 h-4 shrink-0"
			>
			</svg-icon>
		</a>
	</div>
</template>

<script>
import {notify} from "@kyvg/vue3-notification";
import Client from "../../js/modules/Client";
import Avatar from "./Avatar.vue";

export default {
	components: {Avatar},
	props: [
		'canVote',
		'type',
		'voted',
		'rate',
		'id',
	],
	data() {
		return {
			isInternalChange: false,
			rating: this.rate || 0,
			userRate: this.voted ? Number(this.voted) : 0,
			loading: false,
			votersTimeout: false,
			votersCloseTimeout: false,
			voters: [],
			votersLoading: false,
			votersLoaded: false,
			votersOpen: false,
		}
	},
	updated() {
		if (!this.isInternalChange) {
			this.rating = this.rate;
		}
	},
	methods: {
		url(method = 'rate') {
			if (this.type === 'post') {
				return '/api/v1.1/posts/' + this.id + '/' + method;
			}
			if (this.type === 'comment') {
				return '/api/v1.1/comments/' + this.id + '/' + method;
			}
		},
		vote(e, rate) {
			if (this.loading) {
				notify({
					type: 'error',
					text: 'Да падажжи, ща все будет, я задумался',
				});
				return;
			}

			this.isInternalChange = true;
			this.loading = true;

			if (this.userRate !== 0) {
				this.rating -= this.userRate;

				if (this.userRate !== rate) {
					this.rating += rate;
				}

			} else {
				this.rating += rate;
			}

			if (rate < 0 && this.isFriday13()) {
				this.showScreamer();
			}

			let rateToSend = this.userRate === rate ? 0 : rate;
			this.userRate = this.userRate === rate ? 0 : rate;

			Client.post(this.url('rate'), {
				rate: rateToSend,
			}).then(response => {
				this.rating = response.data.data.rate;
				this.userRate = response.data.data.voted;
				this.voters = response.data.data.voters;
			}).catch(error => {
				notify({
					type: 'error',
					text: error.response.data.message || 'Не вышло',
				});
			}).finally(() => {
				this.loading = false;
				this.isInternalChange = false;
			});
		},
		loadVoters() {
			if (!this.canVote) {
				return;
			}

			if (this.votersLoaded) {
				this.votersOpen = true;
				return false;
			}

			if (this.votersTimeout) {
				clearTimeout(this.votersTimeout);
			}

			if (this.votersCloseTimeout) {
				clearTimeout(this.votersCloseTimeout);
			}

			this.votersTimeout = setTimeout(() => {
				this.votersLoading = true;
				this.votersOpen = true;

				Client.get(this.url('voters'))
					.then(response => {
						this.voters = response.data.data;
						this.votersLoading = false;
						this.votersLoaded = true;
					})
					.catch(error => {
						notify({
							type: 'error',
							text: 'Чот никак',
						});
						this.votersLoading = false;
						this.votersLoaded = true;
					})
				;
			}, 500);
		},
		clearVoters(event) {
			if (!this.canVote) {
				return;
			}

			if (this.votersTimeout) {
				clearTimeout(this.votersTimeout);
			}

			if (this.votersCloseTimeout) {
				clearTimeout(this.votersCloseTimeout);
			}
			this.votersCloseTimeout = setTimeout(() => {
				this.votersOpen = false;
			}, 500);
		},
		closeVoters() {
			this.votersOpen = false;
		},
		showScreamer() {
			const screamer = document.querySelector('#screamer-popup');
			const audio = document.querySelector('#screamer-audio');

			if (audio) {
				audio.play();
			}

			if (screamer) {
				screamer.classList.remove('hidden');
				screamer.classList.add('flex');

				setTimeout(() => {
					screamer.classList.remove('flex');
					screamer.classList.add('hidden');
				}, 300);
			}
		},
		isFriday13() {
			const today = new Date();
			return today.getDate() === 13 && today.getDay() === 5;
		}
	},
}
</script>
